import { format } from 'date-fns'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { selectUser } from 'shared/state/userSlice'
import { getInitials } from 'shared/utils/users'

export function useInitialsDateShortcut() {
    const user = useSelector(selectUser)

    useEffect(() => {
        function handleKeyDown(e: KeyboardEvent) {
            const isAltY = e.altKey && (e.key === 'y' || e.code === 'KeyY')
            if (!isAltY) return

            if (!user.firstName && !user.nickname) return

            const el = document.activeElement
            const isInput =
                el instanceof HTMLInputElement ||
                el instanceof HTMLTextAreaElement ||
                (el instanceof HTMLElement && el.isContentEditable)
            if (!isInput) return

            e.preventDefault()

            const text = `${getInitials(user)} ${format(new Date(), 'dd-MMM-yyyy')}`
            document.execCommand('insertText', false, text)
        }

        document.addEventListener('keydown', handleKeyDown)
        return () => document.removeEventListener('keydown', handleKeyDown)
    }, [user])
}
